module.exports = __webpack_public_path__ + "assets/images/edge830-e9af0eb77152cb0df3a4662a16720d94.jpg";